/**
 * Hotels Flavor Module
 *
 * Provides the hotel booking experience: room search, room cards display,
 * booking management, and media gallery.
 *
 * Extends BaseFlavor — all universal handlers (show_items, cart_updated,
 * show_media, dismiss_media) are wired automatically.
 * No extra handlers needed — uses the standard contract only.
 */
import { BaseFlavor } from './BaseFlavor.js';
import { HotelsManager } from '../hotels/HotelsManager.js';

class HotelsFlavor extends BaseFlavor {
  constructor(widget, flavorOpts) {
    super(widget, flavorOpts, {
      buttonText: 'Book this room',
      priceLabel: 'per night',
    });
  }

  createManager({ shadowRoot, primaryColor }) {
    return new HotelsManager({
      shadowRoot,
      primaryColor,
      onRoomSelected: (room) => this.handleItemSelected(room),
    });
  }

  getManagerHideMethod() {
    return 'hideRooms';
  }
}

export function createHotelsFlavor(widget, flavor = {}) {
  return new HotelsFlavor(widget, flavor);
}
